<template>
  <div class="rounded bg-gray-100">
    <div class="h-full animated-background rounded"></div>
  </div>
</template>

<script setup></script>

<style scoped>
@keyframes placeHolderShimmer {
  0% {
    background-position: -50%;
  }
  100% {
    background-position: 600%;
  }
}

.animated-background {
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f1f5f9;
  background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
  background-size: 50% 100%;
  background-repeat: no-repeat;
  position: relative;
}
</style>
